export const isValidEmail = (email: string): boolean => {
  const emailRegExp =  /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  return emailRegExp.test(email);
};
